"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export default function UserMenu() {
  const router = useRouter();
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/me")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setUsername(d?.username ?? null))
      .catch(() => {});
  }, []);

  if (!username) return null;

  async function logout() {
    await fetch("/api/logout", { method: "POST" });
    router.replace("/login");
  }

  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="text-muted">{username}</span>
      <Link href="/settings" className="text-foreground hover:text-cyan transition-colors">
        Settings
      </Link>
      <button onClick={logout} className="text-foreground hover:text-cyan transition-colors">
        Sign out
      </button>
    </div>
  );
}
